"use strict";

var Reflux = require("reflux");
var Intl = require("intl");
var ReactIntl = require("react-intl");
var ListingStore = require("app/shared/stores/listing-store");
var CurrencyValue = require("app/shared/components/List/currency-value.jsx");

var DealsListingTotalValue = React.createClass({
	mixins: [Reflux.ListenerMixin, ReactIntl.IntlMixin],
	getInitialState: function(){
		return ListingStore.getDefaultData();
	},
		componentDidMount: function() {
				this.listenTo(ListingStore, this.setState);
		},
	render: function(){
		var totalResults = this.state.totalResults || 0;
		var resultsText = this.formatMessage(this.getIntlMessage("deal.total_results.text"), {
			deals: totalResults
		});

		return (
		<div className="bootstrap-agendor">
			<div className="toolsTitulo">
				<span className="toolsTituloTexto fs-14 fw-bold">Valor total dos seus negócios</span>
			</div>
			<ul className="toolsBox">
				<li className="valor">
					<CurrencyValue value={this.state.dealsTotalValue} symbol="R$" />
				</li>
				<li><span className="listing-deals-total-results small mt-5 c-lightGrey">{resultsText}</span></li>
			</ul>
		</div>);
	}
});

module.exports = DealsListingTotalValue;



// WEBPACK FOOTER //
// ./app/shared/components/List/deals-listing-total-value.jsx